<template>
  <v-row>
    <v-col
      v-if="!isLoading"
      cols="12"
      class="mb-3 mb-md-5"
    >
      <heading v-if="product">
        {{ product.name ?? '' }}
      </heading>
    </v-col>
    <horizontal-loader v-if="isLoading">
      <div class="text-center">
        Laster...
      </div>
    </horizontal-loader>
    <v-col
      v-if="!isLoading && product"
      cols="12"
    >
      <v-row>
        <v-col
          cols="12"
          class="d-md-none"
          data-note="Mobile-top"
        >
          <product-price-section
            :product="product"
            :prices="sortedPrices"
          />
          <!--          TODO : Add similar products component-->
        </v-col>
        <v-col cols="12" md="4" data-note="Details">
          <product-detail-section
            :product="product"
            :prices="sortedPrices"
          />
        </v-col>
        <v-col cols="12" class="d-sm-block d-md-none">
          <similar-products-widget
            :product="product"
            :limit="4"
            v-if="$vuetify.display.smAndDown"
          />
        </v-col>
        <v-col
          data-note="Desktop-right"
          cols="12"
          md="8"
          class="d-none d-md-block"
        >
          <v-row>
            <v-col cols="12">
              <product-price-section
                :product="product"
                :prices="sortedPrices"
              />
              <!--          TODO : Add similar products component-->
            </v-col>
            <v-col cols="12" class="d-sm-none d-md-block">
              <similar-products-widget
                :product="product"
                :limit="4"
                v-if="$vuetify.display.mdAndUp"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script setup lang="ts">
import {computed, onMounted, ref, watch} from "vue";
import {Configuration, Product} from "@/lib/keys";
import HorizontalLoader from "@/components/shared/horizontal-loader.vue";
import Heading from "@/components/typography/heading.vue";
import ProductDetailSection from "@/components/shared/product/product-detail-section.vue";
import ProductPriceSection from "@/components/shared/product/product-price-section.vue";
import {useRoute, useRouter} from "vue-router";
import {useProductStore} from "@/store/product";
import {usePriceData} from "@/composables/price-data";
import {useSeoMeta} from "@vueuse/head";
import {useProductSnippet} from "@/composables/structured-json-snippets";
import {RouteName} from "@/keys";
import SimilarProductsWidget from "@/components/shared/product/similar-products-widget.vue";
import {useGtag} from "vue-gtag-next";

const route = useRoute();
const router = useRouter();
const productStore = useProductStore();
const snippet = useProductSnippet();
const priceData = usePriceData();
// const gtag = useGtag();

const product = ref<Product>();
const sortedPrices = ref<Configuration[]>([])
const isLoadingTimeout = ref<boolean | undefined>(undefined);
const isLoading = computed(() => isLoadingTimeout.value ?? product.value?.name === undefined);
const merchantCount = computed(() => !isLoading.value && product.value ? product.value.prices.length : '5+')


const loadProduct = async () => {
  const matchedProducts = await productStore.getBySlug(route.params.product as string);

  if (matchedProducts.length === 0) {
    await router.replace(RouteName.website.notFound)
    return;
  }

  product.value = matchedProducts[0] as Product;
  sortedPrices.value = priceData.buildSortedPrices(product.value);

  snippet.setProduct(product.value, location.href);

  //track
  // gtag.
}

onMounted(loadProduct)

watch(() => route.params.product, loadProduct)

const pageTitle = (): string => !isLoading.value && product.value ? `Hvor mye koster ${product.value.name}? - her finner du ${merchantCount.value} forskjellige priser` : '';
const pageDescription = (): string => !isLoading.value && product.value ? `Lurer du på hvor mye ${product.value.name} koster? Her finner du priser hos ${merchantCount.value} nettsider, ${product.value?.merchants.map(m => m.name).join(', ')}.` : '';

//
useSeoMeta({
  title: pageTitle,
  description: pageDescription,
  ogTitle: pageTitle,
  ogDescription: pageDescription,
  //@ts-ignore
  ogType: 'product',
  robots: 'index, follow',

});
</script>
